export const normalizeProductDefinitionId = (value: unknown): string | undefined => {
  if (Array.isArray(value)) {
    const firstValue = value[0]
    return typeof firstValue === 'string' && firstValue ? firstValue : undefined
  }

  if (typeof value === 'string' && value) {
    return value
  }

  return undefined
}

const normalizeString = (value: unknown): string | undefined => {
  if (Array.isArray(value)) {
    const firstValue = value[0]
    return typeof firstValue === 'string' && firstValue ? firstValue : undefined
  }

  if (typeof value === 'string' && value) {
    return value
  }

  return undefined
}

const getProviderNameFromUnknownIdentities = (identities: unknown): string | undefined => {
  if (Array.isArray(identities)) {
    const provider = identities.find(
      (identity) => identity && typeof identity === 'object' && typeof identity.providerName === 'string'
    ) as { providerName?: string } | undefined
    return normalizeString(provider?.providerName)
  }

  if (typeof identities === 'string') {
    try {
      const parsed = JSON.parse(identities)
      return getProviderNameFromUnknownIdentities(parsed)
    } catch {
      return undefined
    }
  }

  if (identities && typeof identities === 'object' && typeof (identities as any).providerName === 'string') {
    return normalizeString((identities as any).providerName)
  }

  return undefined
}

export interface AutoEnrollmentUserContext {
  SSOFederatedIdentityId?: string
  StudentFirstName?: string
  StudentLastName?: string
  StudentEmail?: string
  StudentExternalId?: string
}

export const getAutoEnrollmentUserContext = (payload?: Record<string, unknown>): AutoEnrollmentUserContext => {
  const studentEmail = normalizeString(payload?.email)

  return {
    SSOFederatedIdentityId:
      normalizeString(payload?.['custom:federated_override']) ??
      getProviderNameFromUnknownIdentities(payload?.identities),
    StudentFirstName: normalizeString(payload?.given_name),
    StudentLastName: normalizeString(payload?.family_name),
    StudentEmail: studentEmail,
    StudentExternalId:
      normalizeString(payload?.['custom:sub_override']) ??
      normalizeString(payload?.['custom:externalUserId']) ??
      normalizeString(payload?.sub) ??
      studentEmail,
  }
}
